import React from 'react'
import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { IconButton } from '@mui/material'
import { HelpOutline as HelpCircle } from '@emotion-icons/material/HelpOutline'
import { InsightCardWrapperProps } from 'src/components/insights/common/cards/card'
import { HelpTooltip } from 'src/components/help-tooltip'

type InsightCardMapProps = {
  children?: React.ReactNode
  tooltipFile?: string
}

export const InsightCardGrayWrapper = styled.div<InsightCardWrapperProps>`
  position: relative;
  display: flex;
  width: 100%;
  background-color: ${Colors.bgDark};
  align-items: center;
  margin: ${Shapes.spacing[4]}px 0;
  border: 1px solid ${Colors.border};
  padding: 0;
  padding: ${(props: InsightCardWrapperProps) =>
    props.padding !== undefined ? `${props.padding}px` : `${Shapes.spacing[4]}px`};
  border-radius: ${(props: InsightCardWrapperProps) =>
    props.isFooterOpen ? `${Shapes.borderRadius}px ${Shapes.borderRadius}px 0 0` : Shapes.borderRadius}px;
  overflow: hidden;
`

export const InsightCardGrayContent = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`

export const InsightCardGrayContentRightBtn = styled(IconButton)`
  width: 20px;
  height: 20px;
  padding: 0;
`

export const InsightCardGrayContentHelpCircleIcon = styled(HelpCircle)`
  width: 16px;
  height: 16px;
`

export const InsightCardGray: React.FC<InsightCardMapProps> = (props) => {
  const { children, tooltipFile } = props

  return (
    <InsightCardGrayWrapper>
      <InsightCardGrayContent>{children}</InsightCardGrayContent>
      {tooltipFile && (
        <HelpTooltip file={tooltipFile} placement="bottom" immediate>
          <InsightCardGrayContentRightBtn aria-label="Help">
            <InsightCardGrayContentHelpCircleIcon />
          </InsightCardGrayContentRightBtn>
        </HelpTooltip>
      )}
    </InsightCardGrayWrapper>
  )
}
